import React, { useState } from "react";
import "../styles/Financials.css";

const Financials = () => {

    const financialData = [
        { year: 2026, shareholders: 24289, share: 928.47, reserve: 5119.51, deposits: 15778.53, loans: 9764.41, working: 21319.98, employees: 66, npa: 0.55},
        { year: 2025, shareholders: 24137, share: 965.26, reserve: 5369.03, deposits: 16525.07, loans: 9838.80, working: 23093.07, employees: 54 },
        { year: 2024, shareholders: 24071, share: 1000.63, reserve: 5440.18, deposits: 17600.91, loans: 9168.84, working: 22894.34, employees: 54 },
        { year: 2023, shareholders: 23908, share: 1008.59, reserve: 4481.97, deposits: 19076.92, loans: 9906.67, working: 23963.97, employees: 57 },
        { year: 2022, shareholders: 23981, share: 991.4, reserve: 4754.83, deposits: 20279.49, loans: 10426.45, working: 26432.01, employees: 64 },
        { year: 2021, shareholders: 24120, share: 996.36, reserve: 4537.24, deposits: 21597.93, loans: 12240.80, working: 24608.64, employees: 79 },
        { year: 2020, shareholders: 24096, share: 975.02, reserve: 4207.99, deposits: 21117.11, loans: 12718.24, working: 26113.71, employees: 83 },
        { year: 2015, shareholders: 23642, share: 862.61, reserve: 3076.35, deposits: 24166.21, loans: 14760.69, working: 27953.5, employees: 66 },
        { year: 2010, shareholders: 20664, share: 480.51, reserve: 972.16, deposits: 14206.86, loans: 7566.92, working: 15851.37, employees: 93 },
        { year: 2005, shareholders: 16915, share: 279.85, reserve: 796.82, deposits: 5837.89, loans: 2649.73, working: 7037.04, employees: 122 },
        { year: 2000, shareholders: 14591, share: 221.07, reserve: 324.77, deposits: 3910.54, loans: 2272.27, working: 4716.72, employees: 138 },
        { year: 1995, shareholders: 11295, share: 150.87, reserve: 212.58, deposits: 2088.94, loans: 1715.44, working: 2681.31, employees: 147 },
        { year: 1990, shareholders: 9247, share: 81.48, reserve: 56.25, deposits: 1150.65, loans: 974.26, working: 1403.42, employees: 144 },
        { year: 1985, shareholders: 5830, share: 47.08, reserve: 21.4, deposits: 451.96, loans: 281.68, working: 547.49, employees: 100 },
        { year: 1980, shareholders: 4041, share: 29.22, reserve: 5.28, deposits: 191.77, loans: 134.71, working: 230.85, employees: 74 },
        { year: 1975, shareholders: 2447, share: 9.23, reserve: 1.95, deposits: 46.97, loans: 36.13, working: 59.65, employees: 35 },
        { year: 1970, shareholders: 1431, share: 2.46, reserve: 0.02, deposits: 6.05, loans: 5.27, working: 10.8, employees: 15 },
        { year: 1968, shareholders: 833, share: 0.87, reserve: 0, deposits: 0.12, loans: 0.63, working: 0.75, employees: 12 }
    ];

    const [selectedYear, setSelectedYear] = useState(2025);
    const current = financialData.find(d => d.year === selectedYear);

    return (
        <main className="financials-container">

            {/* HERO */}
            <section className="financials-hero">
                <h1>Financial Overview</h1>
                <p>
                    Our Board bears collective responsibility for securing long-term prosperity
                    and maintaining strong governance across all financial operations.
                </p>
            </section>


            {/* CONTENT + IMAGE */}
            <section className="financial-content">
                <div className="text-content">
                    <h2>Strategic Financial Governance</h2>
                    <p>
                        Our Board bears collective responsibility for securing our long-term prosperity and for maintaining a robust framework of effective controls within the Bank. Explore the financial landscape with ease by accessing our comprehensive list of bank annual reports. Gain valuable insights into bank's performance and strategic outlook as you navigate through the detailed financial narratives provided in these reports. The Board plays a pivotal role in charting our strategic course, sanctioning our strategic plans, and taking necessary measures to ensure we have the requisite resources to fulfill our strategic ambitions. It diligently considers the ramifications of its decisions and recognizes its fiduciary duties to all stakeholders, encompassing employees, shareholders, regulators, clients, suppliers, and the welfare of the communities in which we operate, enhancing our commitment to rigorous oversight and compliance.
                    </p>
                    <p>
                        The Board is further committed to fostering a culture of transparency, accountability, and ethical conduct across all levels of the organization. Through regular Board evaluations and performance reviews, we ensure that our governance structures remain agile, relevant, and aligned with evolving regulatory expectations and industry best practices. Our independent non-executive directors bring a wealth of diverse expertise and impartial judgment to Board deliberations, reinforcing balanced decision-making and safeguarding the interests of all stakeholders.
                        In fulfilling its oversight mandate, the Board is supported by a number of specialized committees, including the Audit Committee, Risk Committee and Nominations Committee. Each committee operates under clearly defined terms of reference and reports directly to the full Board, ensuring that critical areas such as financial integrity, risk appetite, executive compensation, and board composition receive the focused attention they warrant.
                    </p>

                </div>

                <section>
                    <div className="image-content">
                        <img
                            src="https://images.unsplash.com/photo-1559526324-593bc073d938?auto=format&fit=crop&w=1200&q=80"
                            alt="Financial Growth"
                        />
                    </div>
                </section>
            </section>

            {/* REPORT DOWNLOAD SECTION */}
            <section className="report-section">
                <h2>Annual Reports</h2>

                <div className="report-cards">
                    <a href="/forms/58th_Annual_Report_2025_2026.pdf" download className="report-card">
                        58th Annual Report (2025-2026)
                    </a>

                    <a href="/forms/57th_Annual_Report_2024_2025.pdf" download className="report-card">
                        57th Annual Report (2024-2025)
                    </a>

                    <a href="/forms/56th_Annual_Report_2023_2024.pdf" download className="report-card">
                        56th Annual Report (2023-2024)
                    </a>
                </div>
            </section>

            {/* YEAR SELECTOR */}
            <section className="year-selector">
                {financialData.map(item => (
                    <button
                        key={item.year}
                        className={selectedYear === item.year ? "active-year" : ""}
                        onClick={() => setSelectedYear(item.year)}
                    >
                        {item.year}
                    </button>
                ))}
            </section>

            {/* SNAPSHOT */}
            <section className="financial-snapshot">
                <div className="snapshot-card"><h4>Shareholders</h4><p>{current.shareholders}</p></div>
                <div className="snapshot-card"><h4>Share Capital</h4><p>₹ {current.share} Lakhs</p></div>
                <div className="snapshot-card"><h4>Reserve Fund</h4><p>₹ {current.reserve} Lakhs</p></div>
                <div className="snapshot-card"><h4>Deposits</h4><p>₹ {current.deposits} Lakhs</p></div>
                <div className="snapshot-card"><h4>Loans</h4><p>₹ {current.loans} Lakhs</p></div>
                <div className="snapshot-card"><h4>Working Capital</h4><p>₹ {current.working} Lakhs</p></div>
                <div className="snapshot-card"><h4>Employees</h4><p>{current.employees}</p></div>
                <div className="snapshot-card"><h4>Net NPA</h4><p>{current.npa}%</p></div>
            </section>

        </main>
    );
};

export default Financials;